<template>
  <div class="switch-role flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title">Role Management</span>
    </div>
    <transition name="slide-up">
      <div v-if="!isLoading">
        <div class="a-body pt-3 flex-grow-1" >
          <span class="fw-b ml-3">Current Role: </span>
          <span>{{ userName }}</span>
          <template v-if="parentUserName != userName">
            <span class="fw-b ml-3">Original Role: </span>
            <span>
              {{ parentUserName }}
              <a v-if="parentUserRecord && parentUserRecord.username == parentUserName" @click="onSwitchRole(parentUserRecord)">(switch)</a>
            </span>
          </template>

          <div class="mt-3 ml-3 mr-3">
            <a-alert message="There are no other roles available" type="error" showIcon v-if="data.length == 0" />
          </div>

          <div class="fw-b ml-3" v-if="data && data.length > 0">
            Select a role to switch to:
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-up">
      <div v-if="!isLoading && data && data.length > 0" class="a-filter">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="10">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @change="onSearch" />
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="columns"
            :dataSource="filterData"
            :tableSize="tableSize"
            v-if="data && data.length > 0">
            <div slot="username" slot-scope="{ record }">
              <a :key="record.username" class="username" @click="onSwitchRole(record)">
                {{ record.username }}
              </a>
            </div>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer" v-if="data && data.length > 0">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  const columns = [
    {
      title: 'No.',
      dataIndex: 'index',
      sorter: (a, b) => a.index - b.index
    },
    {
      title: 'Username',
      dataIndex: 'username',
      slot: 'username',
      sorter: (a, b) => a.username.localeCompare(b.username)
    },
    {
      title: 'Description',
      dataIndex: 'description',
      sorter: (a, b) => a.description.localeCompare(b.description)
    }
  ];

  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import JwtService from '@shared/services/jwt.service';
  import AccountService from '../services/account.service';

  export default {
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize) {
        pageSize = 5;
      }

      return {
        data: [],
        userName: '',
        parentUserName: '',
        columns,
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        filterParams: {
          search: '',
        },
        tableSize: {
          height: '',
          width: '',
        },
        isLoading: true,
        PAGE_OPTIONS
      };
    },
    mounted() {
      this.loadData();
    },
    computed: {
      parentUserRecord() {
        let parentUserRecord = null;
        this.data.forEach((record) => {
          if (record.username === this.parentUserName) {
              parentUserRecord = record;
          }
        });
        return parentUserRecord;
      }
    },
    methods: {
      async loadData() {
        await Promise.all([this.getSwitchUser(), this.getUserInRole(), this.getParentUser()]);
        this.isLoading = false;
      },
      async getSwitchUser() {
        const data = await AccountService.getSwitchUser();
        this.data = (data || []).map((item, index) => ({ ...item, index: index + 1 }));
        this.pagin.total = data.length;
        this.filter();
      },
      async onSwitchRole(record) {
        const data = await AccountService.switchRoleUser(record.id);
        this.$store.dispatch('SETTOKEN', data.token);
        JwtService.setToken(data.token);
        const dataUser = await this.getUserInRole();
        this.$store.dispatch('SETUSER', dataUser);
        this.$showSuccessMessage('Role has been changed');
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getUserInRole() {
        const data = await AccountService.getUserInRole();
        this.userName = data.name;
        return data;
      },
      async getParentUser() {
        const data = await AccountService.getUser();
        this.parentUserName = data.name;
        return data;
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter(item => item.username.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length,
        };
      },
      elSizeChange(size) {
        this.tableSize = size;
      },
    }
  };
</script>
